import { KirbyPageData, baseQuery } from "."
import { KirbyQuerySchema } from "./kql"
import {
  KirbyStudentPageData,
  studentPagePreviewQuery,
  studentPageQuery,
} from "./student"

export interface KirbyGroupPageData extends KirbyPageData {
  students?: KirbyStudentPageData[]
  studentsCustomNames?: string
  programme: KirbyPageData
}

export const groupPageQuery: KirbyQuerySchema["select"] = {
  ...studentPagePreviewQuery,
  students: {
    query: "page.students.toPages",
    select: studentPageQuery,
  },
  studentsCustomNames: "page.studentsCustomNames",
  programme: {
    query: "page.parent",
    select: baseQuery,
  },
}
